export const isChecked = (checkbox, id, checked) => {
  if (typeof checkbox !== 'undefined') {
    if (checkbox === id) {
      return true;
    }
  }
  if (checked) {
    return true;
  }
  return false;
};
